export default "__VITE_ASSET__66f7a693__"